/* Component Dependencies */
var imageTextCarouselTemplate = require('templates/imageTextCarousel.hbs');
var AriesComponent = require('libs/aries-component');
var carouselWidthHandler = require('libs/multiCarousel-width-handler');
AriesComponent.create({
  type: 'imageTextCarousel',
  template: {
    'imageTextCarousel': imageTextCarouselTemplate
  },
  events: {
    'click .js-arrow-click': 'updateImageText',
    'click .vjs-big-play-button': 'pauseVideo'
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  bindEvents: function() {
    var _self = this,
    $carousel;
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]'),
    $carousel = _self.parentSelector.find('.mi-carousel');
    $carousel.on('init', function(event, slick) {
			_self.$el.find('.mi-carousel .l-picture-wrapper img').first().on('load',function () {
				setTimeout(function() {    
              $carousel.addClass('mi-prevent-reinit');
				},100);
			});
		});
    $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var $currentSlide, $nextSlide;
      if (currentSlide !== nextSlide) {
        $currentSlide = slick.$slides.eq(currentSlide);
        $nextSlide = slick.$slides.eq(nextSlide);
        if ($currentSlide.hasClass('l-video-wrapper')) {
          $currentSlide.find('video').get(0).pause();
        }
      }
    });
  },
  updateImageText: function(elm) {
    var _self = this;
    _self.leftArrow = _self.$el.find('button.slick-prev');
    _self.rightArrow = _self.$el.find('button.slick-next');
   if($(elm.target).hasClass('right-arrow')){
      _self.rightArrow.click();
   }
   else{
      _self.leftArrow.click();
   }
    
  },
  pauseVideo: function(e) {
    var $this = $(e.currentTarget);
    if($this.siblings('video').parent('.mi-video').hasClass('vjs-playing')) {
      $this.siblings('video').get(0).pause();
    }
  }

});
